<app-static-pages-header [title]="'Allgemeine Nutzungsbedingungen (ANB)'"></app-static-pages-header>
<div class="container anb">
  <div class="row justify-content-md-center">
    <div class="col-md-8">
      <h2 class="main__title">Allgemeine Nutzungsbedingungen</h2>
      <ol class="app__justify-text">
        <li>
          <h5>Geltungsbereich</h5>
          <p>
            Die folgenden Allgemeinen Nutzungsbedingungen (ANB) gelten für alle Nutzungshandlungen und
            Geschäftsbeziehungen zwischen dem Nutzer einerseits und der SFA Sport GmbH (im Folgenden kurz: SFA)
            andererseits aus der Nutzung der Online-Plattform und Services „fan.at“ (im Folgenden kurz: Plattform).
            Maßgeblich ist jeweils die zum Zeitpunkt der Nutzung gültige Fassung der ANB.
            Abweichende, entgegenstehende oder ergänzende AGB/ANB des
            Nutzers werden, selbst bei Kenntnis, nicht Vertragsbestandteil, es sei denn, SFA hätte ihrer Geltung
            ausdrücklich schriftlich zugestimmt. AGB/ANB des Nutzers widerspricht SFA hiermit ausdrücklich.
            Auf mögliche zukünftige Änderungen der ANB wird der Nutzer ausdrücklich hingewiesen.
            Mit der weiteren Nutzung der Services der Plattform akzeptiert der Nutzer auch die Änderungen der ANB.
          </p>
        </li>
        <li>
          <h5>Plattform</h5>
          <p>
            SFA stellt Akteuren des österreichischen Amateurfußballs eine „Medienplattform“ zur
            Abrufbarhaltung von Informationen über den Verein, dessen Leistungen und Neuigkeiten zur Verfügung.
            <br>
            <br>
            Ein Großteil der veröffentlichten Informationen („Content“) stammt von den Akteuren.
            SFA kommt in diesen Fällen lediglich die Rolle eines rein technischen Verbreiters/Hosts zu, der auf
            den veröffentlichten Content der Gemeinden und Akteure keinen Einfluss nimmt und diesen
            weder beaufsichtigt, noch auf dessen Richtigkeit hin überprüft. Für den Content ist der
            Akteur selbst verantwortlich. Eine Verantwortlichkeit der SFA kann gemäß § 16 Abs 1 ECG erst
            dann eintreten, wenn SFA von einem rechtswidrigen Content Kenntnis hat und diesen nicht
            unverzüglich nach Kenntniserlangung entfernt/sperrt.
          </p>
        </li>
        <li>
          <h5>Eigentum an der Plattform</h5>
          <p>
            Die Plattform (samt ihren Inhalten) steht in ihrer Gesamtheit und in ihren Teilen im Eigentum
            von SFA und ist urheberrechtlich geschützt.
          </p>
        </li>
        <li>
          <h5>Grundsätzliche Unentgeltlichkeit der Nutzung durch den Nutzer</h5>
          <p>
            Die Nutzung der Plattform ist – soweit nichts anderes angegeben – für den Nutzer
            grundsätzlich kostenfrei. Aus der kostenlosen Bereitstellung der Plattform ist für den
            Nutzer kein Rechtsanspruch für die Zukunft ableiten. SFA behält sich vor, Plattformen und Services
            jederzeit (teilweise) einzustellen, (teilweise) kostenpflichtig zu stellen oder
            (teilweise) einzuschränken sowie einen Nutzer ohne Angabe von Gründen zu sperren.
            Bei zahlungspflichtigen Services erfolgt die Abrechnung über die vorgegebenen Zahlungsmöglichkeiten.
          </p>
        </li>
        <li>
          <h5>Registrierung</h5>
          <p>
            Einzelne Funktionalitäten der Plattform setzen eine Registrierung voraus.
            Mit der Registrierung erklärt der Nutzer verbindlich sein Vertragsangebot
            zur registrierten Nutzung, das von SFA durch Freischaltung angenommen werden kann.
            Bei der Registrierung hat der Nutzer die abgefragten Daten, insbesondere seinen
            Vor- und Nachnamen sowie seine E-Mail-Adresse, richtig bekanntzugeben und die ANB in der
            jeweils gültigen Fassung zu akzeptieren. Die Daten sind im laufenden Nutzungsverhältnis aktuell zu halten.
            <br>
            <br>
            SFA ist berechtigt, das Angebot des Nutzers zur Freischaltung ohne Angabe von Gründen abzulehnen.
            <br>
            <br>
            Zur Vermeidung der missbräuchlichen Verwendung seines Accounts ist der
            Nutzer verpflichtet, sein Passwort geheim zu halten und es in keiner Weise
            Unbefugten zukommen zu lassen. Der Nutzer ist nicht berechtigt, seinen Account
            einem Dritten teilweise oder vollständig, entgeltlich oder unentgeltlich
            zur Nutzung zu überlassen. Sollte es zu Unregelmäßigkeiten kommen, so soll
            der Nutzer SFA von diesen Störungen unverzüglich in Kenntnis setzen.
            SFA wird den Nutzer niemals außerhalb der Eingabemaske für das Passwort
            dazu auffordern, sein Passwort zu übermitteln.
          </p>
        </li>
        <li>
          <h5>Rücktritts- bzw. Kündigungsrecht</h5>
          <p>
            Der Nutzer ist, soweit er Konsument im Sinne des KSchG oder Verbraucher
            im Sinne des FAGG ist, gemäß § 3 KSchG und § 4 Abs 1 Z 8 FAGG gesetzlich berechtigt, seine
            im Fernabsatz oder außerhalb der Geschäftsräumlichkeiten von SFA abgegebene
            Vertragserklärung (Bestellung) zu widerrufen bzw. (nach erfolgter Annahme (Freischaltung) durch SFA)
            von dem Vertrag zu den Bedingungen der nachstehenden Widerrufserklärung zurückzutreten.
          </p>
          <p>
            <strong>Entfall des Rücktrittsrechtes gemäß § 18 Abs 1 Z 1 FAGG:</strong>
            Das Rücktrittsrecht entfällt, sofern SFA mit ausdrücklicher Zustimmung des Nutzers
            (verbunden mit dessen Kenntnisnahme vom Verlust des Rücktrittsrechts bei vorzeitigem Beginn
            mit der Vertragserfüllung und nach Zurverfügungstellung einer Vertragsbestätigung) noch vor Ablauf
            der Rücktrittsfrist mit der Lieferung begonnen hat.
          </p>
          <p>
            <strong>Rücktrittsfrist:</strong>
            Der Rücktritt ist binnen 14 Tagen nach der Annahme (= Freischaltung) auszuüben.
          </p>
          <p>
            <strong>Widerrufsbelehrung:</strong>
            Gemäß § 3 KSchG und § 4 Abs 1 Z 8 FAGG belehrt SFA
            den Nutzer über nachstehendes gesetzliches Widerrufsrecht:
          </p>
          <h5 class="large">Widerrufsrecht</h5>
          <p>
            Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen.
            Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses (Freischaltung).
            Um Ihr Widerrufsrecht auszuüben, müssen Sie uns, der
            SFA Sport GmbH, Dr. Robert Graf Straße 30/7, 8010 Graz, office@fan.at, mittels einer
            eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder E-Mail)
            über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren.
            Machen Sie von dieser Möglichkeit Gebrauch, so werden wir Ihnen unverzüglich (z. B. per E-Mail)
            eine Bestätigung über den Eingang eines solchen Widerrufs übermitteln. Zur Wahrung der Widerrufsfrist
            reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts
            vor Ablauf der Widerrufsfrist absenden.
          </p>
          <h5 class="large">Folgen des Widerrufs</h5>
          <p>
            Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen
            erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen
            ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags
            bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei
            der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich
            etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
          </p>
        </li>
        <li>
          <h5>Laufzeit/Kündigung</h5>
          <p>
            Das (entgeltliche oder unentgeltliche) Nutzungsverhältnis zwischen SFA und dem
            Nutzer wird grundsätzlich auf unbestimmte Zeit eingegangen.
          </p>
          <p>
            Kostenfreie Services können von jeder Vertragspartei jederzeit mit sofortiger Wirkung gekündigt werden.
          </p>
          <p>
            Kostenpflichtige Services sind von jeder Vertragspartei zum Ende
            des (im Regelfall monatlich oder jährlich) fälligen oder vorausbezahlten Zeitraums kündbar.
            Vorauszahlungszeiträume stellen daher die Vereinbarung einer Mindestlaufzeit dar.
          </p>
          <p>
            Im Falle der Vertragsbeendigung - aus welchem Rechtsgrund immer - bleiben allfällige zuvor
            eingeräumte Nutzungsrechte an dem eingestellten Content des Nutzers unberührt.
          </p>
          <p>
            Nach Beendigung des Vertragsverhältnisses ist SFA berechtigt, aber nicht
            verpflichtet, den Account und den Content des Nutzers umgehend (im Ganzen und in Teilen)
            zu löschen. Bereits erfolgte Rechteeinräumungen bleiben von der Beendigung
            des Nutzungsverhältnisses unberührt.
          </p>
        </li>
        <li>
          <h5>Verfügbarkeit</h5>
          <p>
            SFA erbringt sämtliche Services jeweils nach Maßgabe der
            bestehenden technischen, wirtschaftlichen, betrieblichen und organisatorischen Möglichkeiten.
            SFA leistet daher keine Gewähr für allfällige
            Unterbrechungen, Störungen, Verspätungen, Löschungen, Fehlübertragungen oder einen Speicherausfall
            in Zusammenhang mit der Inanspruchnahme der Plattformen.
            Der Nutzer nimmt zur Kenntnis, dass die von SFA angebotenen Plattformen auch unter Einbeziehung
            dritter Netzbetreiber angeboten werden. Die Verfügbarkeit der Plattformen ist deshalb von der
            technischen Bereitstellung fremder Dienste abhängig, auf die SFA keinen Einfluss hat.
            <br>
            <br>
            SFA übernimmt keine Verpflichtung, die angebotenen Services unterbrechungsfrei und jederzeit
            online abrufbar zu halten. SFA ist berechtigt, die Dienste
            aus internen Gründen, etwa zu Wartungszwecken, für eine angemessene Zeit zu unterbrechen.
            Der Nutzer kann daraus keine Ansprüche ableiten, SFA wird im Gegenzug auf eine schnelle
            Störungsbeseitigung hinwirken.
          </p>
        </li>
        <li>
          <h5>Gewährleistung</h5>
          <p>
            SFA leistet ausschließlich für entgeltliche Nutzungen Gewähr nach den Bestimmungen der §§ 922 ff ABGB.
          </p>
        </li>
        <li>
          <h5>Haftung</h5>
          <p>
            Die Haftung von SFA und die ihrer Organe, Angestellten, Auftragnehmer
            oder sonstigen Erfüllungsgehilfen („Leute“) ist im Grunde nach auf Vorsatz
            oder grobe Fahrlässigkeit beschränkt; die Haftung für leichte Fahrlässigkeit ist ausgeschlossen.
            Dieser Haftungsausschluss gilt nicht für Personenschäden und Schäden an Sachen, die SFA zur
            Bearbeitung übernommen hat. Soweit die Haftung von SFA ausgeschlossen oder beschränkt
            ist, gilt dies auch für die persönliche Haftung ihrer „Leute“.
          </p>
        </li>
        <li>
          <h5>Gewinnspiele</h5>
          <p>
            Veranstaltet SFA über die Plattform ein Gewinnspiel, so gelten, sofern keine anderen
            Gewinnspielbedingungen angeführt werden, nachstehende Regelungen:
            <br>
            <br>
            <em class="indent-text">
              Mitarbeiter und Erfüllungsgehilfen von SFA sowie der am Gewinnspiel beteiligten Unternehmen
              sind nicht teilnahmeberechtigt. SFA behält sich das Recht vor, Teilnehmer von der
              Verlosung auszuschließen, die die Verlosung unlauter beeinflussen oder das versuchen.
              Die Gewinner werden nach Abschluss des Gewinnspieles ermittelt und per E-Mail benachrichtigt.
              Der Gewinn ist nicht auf Dritte übertragbar. Eine Barauszahlung des Gewinns und der Rechtsweg
              sind ausgeschlossen; der Teilnehmer trägt ihn treffende Steuern aus Eigenem.
            </em>
          </p>
        </li>
        <li>
          <h5>Eingestellter oder übermittelter Content</h5>
          <p>
            SFA stellt seinen Nutzern auf ihren Plattformen Möglichkeiten zur Verfügung, Inhalte
            wie beispielsweise Fotos, Texte, Grafiken, Videos etc. („Content“) einzustellen und damit
            in einem interessierten Forum zu veröffentlichen oder einem anderen Nutzer zu übermitteln.
            Für den Content ist der jeweilige Nutzer selbst verantwortlich. In Bezug auf diesen Content
            kommt der SFA dabei die Rolle eines rein technischen Verbreiters/Hosts zu, der auf
            den verbreiteten Content der Nutzer keinen Einfluss nimmt und diese auch nicht beaufsichtigt.
            Eine Verantwortlichkeit von SFA kann gemäß § 16 Abs 1 ECG erst dann eintreten, wenn SFA von
            einem rechtswidrigen Content Kenntnis hat und diesen nicht unverzüglich nach Kenntniserlangung
            entfernt/sperrt. Sofern Content nach Ansicht des Nutzers Rechte oder Gesetze verletzt, dies bitte
            melden an office@fan.at oder über die entsprechende Kontaktmöglichkeit der Plattform.
            <br>
            <br>
            Der Nutzer räumt SFA für die Dauer der jeweils geltenden gesetzlichen Schutzfrist an den von
            ihm eingestellten Content ein geographisch und sachlich unbeschränktes, übertragbares,
            nicht-exklusives Verwertungs-, Nutzungs- und Bearbeitungsrecht, insbesondere zu Zwecken
            der Abrufbarhaltung, Veröffentlichung und Verbreitung über die Plattform ein.
            <br>
            <br>
            SFA ist nicht verpflichtet, die Inhalte abrufbar zu halten. SFA kann den Content des Nutzers
            jederzeit zurückweisen, an einem anderen Ort veröffentlichen, kürzen oder löschen.
            <br>
            <br>
            Der Nutzer garantiert SFA ausdrücklich, keinen Content einzustellen, dessen Bereitstellung,
            Veröffentlichung oder Nutzung gegen geltendes Recht verstößt oder
            Rechte Dritter (insbesondere Urheberrechte und Persönlichkeitsrechte) verletzt.
            Ausdrücklich untersagt ist die Einstellung von rassistischen, pornographischen,
            menschenverachtenden, beleidigenden und gegen die guten Sitten verstoßenden Contents.
            <br>
            <br>
            Behauptet ein Dritter plausibel, durch den Inhalt in seinen Rechten verletzt
            worden zu sein, so ist SFA berechtigt, aber nicht verpflichtet, die über den
            Nutzer gespeicherten Kontaktdaten bekannt zu geben.
          </p>
        </li>
        <li>
          <h5>Links</h5>
          <p>
            Soweit SFA mit Links den Zugang zu Online-Services dritter Personen ermöglicht, ist SFA für
            die dort enthaltenen fremden Inhalte nicht verantwortlich.
            SFA macht sich die verlinkten Inhalte nicht zu eigen. Sofern Links auf
            rechtswidrige Inhalte verweisen, dies bitte melden an office@fan.at oder über
            die entsprechende Kontaktmöglichkeit der Plattform.
          </p>
        </li>
        <li>
          <h5>Datenschutz</h5>
          <p>
            Die Datenverarbeitung erfolgt auf der Grundlage der separat abrufbar gehaltenen Datenschutzinformation.
          </p>
        </li>
        <li>
          <h5>Sonstiges</h5>
          <p>
            Sollten einzelne Bestimmungen dieses Vertrages ganz oder teilweise unwirksam
            sein oder werden, oder sollte sich in dem Vertrag eine Lücke befinden, so soll hierdurch
            die Gültigkeit der übrigen Bestimmungen nicht berührt werden.
            <br>
            <br>
            Änderungen und Ergänzungen des Vertrages bedürfen der Schriftform.
            Das gilt auch für ein Abgehen von dem Schriftformerfordernis.
            Erklärungen per E-Mail, Telefax oder über die Abfragemaske entsprechen der Schriftform.
            <br>
            <br>
            Soweit in diesem Vertrag auf natürliche Personen bezogene Bezeichnungen nur in männlicher
            Form angeführt sind, beziehen sie sich auf Frauen und Männer in gleicher Weise.
            Bei der Anwendung der Bezeichnung auf bestimmte natürliche Personen ist die
            jeweils geschlechtsspezifische Form zu verwenden.
          </p>
        </li>
        <li>
          <h5>Anwendbares Recht/Gerichtsstand/Erfüllungsort</h5>
          <p>
            Auf dieses Vertragsverhältnis findet materielles österreichisches Recht
            unter Ausschluss der Verweisungsnormen Anwendung.
            <br>
            <br>
            Als Gerichtstand für alle sich mittelbar oder unmittelbar aus dem Vertrag ergebenden
            Streitigkeiten wird das für Graz örtlich und sachlich zuständige österreichische Gericht
            vereinbart. Ist der Nutzer Konsument/Verbraucher, gilt dieser Gerichtstand nur
            dann als vereinbart, wenn er in diesem Gerichtssprengel seinen Wohnsitz, gewöhnlichen Aufenthalt
            oder Ort der Beschäftigung hat oder wenn er im Ausland wohnt.
            <br>
            <br>
            Der Erfüllungsort für die vertragsgegenständlichen Leistungen ist in Graz.
          </p>
        </li>
      </ol>
      <p>Stand: 29.11.2022</p>
    </div>
  </div>
</div>

